import type { PropType } from 'vue-demi'

export const definePropType = <T>(val: any): PropType<T> => val
